// IE 2026 11 01 / ODOO-349799 (group-bytes): текст агрегата (строка-группа, подвал, свёрнутая группа) в формате колонки.
// format 'bytes' → «2.18 KB / 234 MB» (как листовые ячейки, store.formatBytesText); ноль — пусто, как в листьях (store.formatNumberHTML).
// Остальные форматы — прежним путём: fmtFn(n, format) (в гриде это wjcCore.Globalize.format), без fmtFn — null (вызывающий оставляет текст wijmo).
export function formatAggValue(value, format, store, fmtFn = null) {
    if (value === null || value === undefined || value === '') return ''
    const n = Number(value)
    if (!Number.isFinite(n)) return String(value)
    if (format === 'bytes') return n === 0 ? '' : String(store.formatBytesText(n))
    return typeof fmtFn === 'function' ? fmtFn(n, format || 'n0') : null
}
